// extracted by mini-css-extract-plugin
export default {"modalOverlay":"NA-z","modalContent":"OA-z","header":"PA-z","close":"QA-z"};